import { Button, ButtonMode, ButtonSize, ICONS, Icon } from '@creditsights/styleguide-web';

interface CompanyDownloadSnapshotActionProps {
  onClick: () => void;
  loading: boolean;
}

const CompanyDownloadSnapshotAction = ({ onClick, loading }: CompanyDownloadSnapshotActionProps): JSX.Element => (
  <div>
    <Button
      className="no-print to-translate"
      dataTestId="company-download-snapshot-button"
      type="button"
      mode={ButtonMode.SECONDARY}
      size={ButtonSize.MEDIUM}
      onClick={onClick}
      loading={loading}
    >
      <Icon name={ICONS.Download} />
      Snapshot
    </Button>
  </div>
);

export default CompanyDownloadSnapshotAction;
